import React, { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "./AuthContext";
import Logo from "../components/Logo";

export default function Login() {
  const { user, loading, login } = useAuth();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--folk-bg)", color: "var(--folk-muted)" }}>
        Loading…
      </div>
    );
  }
  if (user) {
    const next = location.state?.from?.pathname || "/admin";
    return <Navigate to={next} replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "var(--folk-bg)", display: "flex", alignItems: "center", justifyContent: "center", padding: "24px" }}>
      <div style={{ width: "100%", maxWidth: 420 }}>
        <Logo variant="split" size={20} style={{ marginBottom: 44 }} />
        <h1 className="folk-h1" style={{ marginBottom: 6 }}>Team sign in</h1>
        <p className="folk-body" style={{ marginBottom: 24 }}>
          Access to homeowner responses and persona briefs.
        </p>
        <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <p className="folk-tiny">Email</p>
            <input
              data-testid="login-email"
              className="folk-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="team@folkobjects.com"
              required
              autoFocus
            />
          </div>
          <div>
            <p className="folk-tiny">Password</p>
            <input
              data-testid="login-password"
              className="folk-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && (
            <div data-testid="login-error" style={{ color: "#B5603F", fontSize: 14 }}>
              {error}
            </div>
          )}
          <button
            data-testid="login-submit"
            type="submit"
            className="folk-pill"
            disabled={submitting}
            style={{ marginTop: 6, alignSelf: "flex-start", opacity: submitting ? 0.6 : 1 }}
          >
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
